'use client';

import { OWN_OPENER_ATTR } from '@/components/blocks/quote-link';
import { SmartLink } from '@/components/smart-link';

export interface HeaderQuoteCtaProps {
  href: string;
  label: string;
  className: string;
}

/**
 * The header's "Get Quote" button. It opens the site-wide quote dialog
 * (`window.__bceOpenQuote`, registered by {@link QuoteDialog} in the root
 * layout) — a centered modal on desktop, a bottom sheet on phones — instead of
 * navigating. Because the header sits at the top of the screen, its first tap
 * always lands, unlike a bottom-fixed CTA that competes with iOS Safari's
 * collapsed-toolbar reveal. With no JS the opener is absent and the button falls
 * back to its `href` (the quote page).
 */
export function HeaderQuoteCta({ href, label, className }: HeaderQuoteCtaProps) {
  return (
    <SmartLink
      href={href}
      className={className}
      {...{ [OWN_OPENER_ATTR]: '' }}
      onClick={(event) => {
        const openQuote = window.__bceOpenQuote;
        if (openQuote) {
          event.preventDefault();
          openQuote();
        }
      }}
    >
      {label}
    </SmartLink>
  );
}
